import {defineStore} from 'pinia';

import {fetchWrapper} from '@/helpers/fetch-wrapper';
import {showSuccessToast} from "vant";


const baseUrl = `${process.env.VUE_APP_API_URL}/user/treatment/sessions`;

export const useUserTreatmentSessionStore = defineStore({
    id: 'userTreatmentSession',
    state: () => ({
        userTreatmentSessionStatistics: [],
        overdueUserTreatmentSessions: [],
        userTreatmentSessions: [],
        userTreatmentSession: {
            treatment_session: {
                treatment_session_sections: [],
                treatment_session_goals: []
            },
            user_treatment_resources: []
        },
        name: '',
        status: '',
        step: 0,
        nextId: null,
    }),
    actions: {
        reset() {
            this.userTreatmentSessionStatistics = [],
            this.userTreatmentSessions = [];
            this.userTreatmentSession = {
                treatment_session: {
                    treatment_session_sections: [],
                    treatment_session_goals: []
                },
                user_treatment_resources: []
            };
            this.name = '';
            this.status = '';
            this.step = 0;
        },

        async fetchStatistics(startDate, endDate) {
            const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
            const response = await fetchWrapper.get(`${baseUrl}/statistics` + '?schedule_at_from=' + startDate + "&schedule_at_to=" + endDate + "&account_id=" + accountId, null);
            this.userTreatmentSessionStatistics = response.data;
        },

        async fetchAll(startDate, endDate) {
            if (!startDate) {
                startDate = '';
            }

            if (!endDate) {
                endDate = '';
            }

            const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
            const response = await fetchWrapper
                .get(`${baseUrl}/` + '?name=' + this.name
                    + "&schedule_at_from=" + startDate
                    + "&schedule_at_to=" + endDate
                    + "&status=" + this.status
                    + "&account_id=" + accountId, null);
            this.userTreatmentSessions = response.data;
        },

        async fetchOverdue() {
            const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
            const response = await fetchWrapper
                .get(`${baseUrl}/` + '?'
                    + "overdue=1"
                    + "&account_id=" + accountId, null);
            this.overdueUserTreatmentSessions = response.data;
        },

        async fetchOne(id) {
            this.reset();
            const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
            const response = await fetchWrapper.get(`${baseUrl}/` + id +"?account_id=" + accountId, null);
            this.updateState(response.data);
        },

        async fetchFirstNotStarted() {
            this.reset();
            const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
            const response = await fetchWrapper.get(`${baseUrl}/` + '?account_id=' + accountId + '&status=Not Started', null);
            if (response.data.length > 0) {
                this.updateState(response.data[0]);
            }
        },

        async updateResource(id) {
            const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
            const response = await fetchWrapper.put(`${baseUrl}/` + id +"?account_id=" + accountId, {});
            this.updateState(response.data);
            showSuccessToast('Updated');
        },

        async nextUserTreatmentSession(id) {
            const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
            const response = await fetchWrapper.get(`${baseUrl}/` + id +"/next?account_id=" + accountId);
            this.nextId = response.data.id;
        },

        updateState(data) {
            this.userTreatmentSession = data;
            if (data.status === 'Not Started') {
                this.step = 0;
            } else if (data.status === 'In Progress') {
                this.step = 1;
            } else if (data.status === 'Awaiting Approval') {
                this.step = 2;
            } else if (data.status === 'Completed') {
                this.step = 3;
            }
        }
    }
});
